'use client';

import Link from 'next/link';
import type { ComponentProps } from 'react';
import { trackCta } from '@/lib/attribution';

/**
 * A normal link that also records which button was pressed on which page.
 *
 * It renders as a plain anchor on the server, so it works without JavaScript.
 * The click is stored for the contact flow ("Entry button: /page (hero)") and
 * sent to analytics as `cta_click`, which is interest and never a lead or a
 * sale. Nothing about the visitor is attached.
 */
export function CtaLink({
  cta,
  page,
  href,
  onClick,
  ...rest
}: Omit<ComponentProps<typeof Link>, 'href'> & { cta: string; /** Defaults to the page the click happened on. */ page?: string; href: string }) {
  return (
    <Link
      href={href}
      {...rest}
      onClick={(e) => {
        trackCta(cta, page ?? window.location.pathname, href);
        onClick?.(e);
      }}
    />
  );
}
